import { HrEmpFamilyDetail } from './hrEmpFamilyDetail';


export class EmpInsurance {
  Id: number;
  EmpCode: number;
  NameAsPerRecords: string;
  SumAssured: number;
  SumAssuredParents: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  Age: number;
  DOB: Date;
  PremiumYearId: number;
  IsSubmit: boolean;
  TotalPremium: number;
  SelfPremium: number;
  ParentsPremium: number;
  employeeFamilyDetails: HrEmpFamilyDetail[] = [];
  DOJ: Date;
  FamilyMemberName: string;
  FamilyMemberDOB: Date;
  FamilyMemberAge: number;
  RelationId: number;
  employeeFamilyDetailsonSubmit: EmpInsurance[] = [];


}
